export const createBlogUrl = (title, id) => {
    const slug = title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
        .replace(/\s+/g, "-")         // Replace spaces with hyphens
        .replace(/-+/g, "-");         // Remove duplicate hyphens

    return `${slug}-${id}`;
};